import SetFeaturedBlog from "./SetFeaturedBlog";

export default SetFeaturedBlog;
